module.exports = __webpack_public_path__ + "img/ctrl-pauli-z-stub-mid--i.846eae8c.svg";